import { render, staticRenderFns } from "./StaffEvent.vue?vue&type=template&id=2cc3eaf0&scoped=true"
import script from "./StaffEvent.vue?vue&type=script&lang=js"
export * from "./StaffEvent.vue?vue&type=script&lang=js"
import style0 from "./StaffEvent.vue?vue&type=style&index=0&id=2cc3eaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3eaf0",
  null
  
)

export default component.exports